import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ScriptLoaderService } from '@app/shared/services/script-loader/script-loader.service';

@Component({
  standalone: false,
  selector: 'sbnb-schedule-meeting-dialog',
  templateUrl: './schedule-meeting-dialog.component.html',
})
export class ScheduleMeetingDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ScheduleMeetingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public meetingUrl: string,
    private scriptLoader: ScriptLoaderService
  ) { }

  ngOnInit() {
    if (this.meetingUrl) {
      setTimeout(() => {
        this.scriptLoader
          .load({
            name: 'Hubspot',
            src: 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js',
          })
          .subscribe(() => { });
      }, 500);
    }
  }

  close() {
    this.dialogRef.close();
  }
}
